import request from '@/utils/request'

let CollectionApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.collection/index', data);
  },
  /*保存数据*/
  saveData(data) {
    return request._post('/shop/plus.collection/index', data);
  },
}
export default CollectionApi;



// WEBPACK FOOTER //
// ./src/api/collection.js